import { Header } from "common/components/Header";
import { MessageBannersBox } from "common/components/MessageBannersBox";
import { Paths } from "common/paths/paths";
import { PERMISSIONS } from "config";
import { UserPermissions } from "lib/services";
import React, { FC, useEffect } from "react";
import { BrowserRouter, Route, Switch, useHistory } from "react-router-dom";
import AiForMePage from "view/Page/AiForMe/AiForMe";
import AiForMeIntakePage from "view/Page/AiForMe/AiForMeIntake";
import AiFormeLandingPage from "view/Page/AiForMe/AiFormeLandingPage";
import { MyAiTools } from "view/Page/AiForMe/MyAiTools";
import { WhatsNew } from "view/Page/AiForMe/WhatsNew";
import { AllAiTools } from "view/Page/AllAiTools/AllAiTools";
import ApprovalPage from "view/Page/ApprovalPage";
import CheckoutPage from "view/Page/CheckoutPage/CheckoutPage";
import DetailsPage from "view/Page/DetailsPage";
import FAQPage from "view/Page/FAQ";
import HomePage from "view/Page/Home";
import ListsAdminPage from "view/Page/Lists/ListsAdmin/ListsAdminPage";
import ListsPage from "view/Page/Lists/ListsPage";
import NotFoundPage from "view/Page/NotFound";
import OrderConfirmation from "view/Page/OrderConfirmation/OrderConfirmation";
import { OrdersApprovalPage } from "view/Page/OrdersApprovalPage";
import { OrdersPage } from "view/Page/OrdersPage";
import SearchResultsHardwarePage from "view/Page/SearchResultsHardwarePage/SearchResultsHardwarePage";
import SearchResultsV2 from "view/Page/SearchResultsV2";
import SessionExpired from "view/Page/SessionExpired/SessionExpired";

import { AiForMeRouteComponent } from "./route-helpers";

interface RoutesProps {
  isDarkMode: boolean;
  onDarkModeToggle: () => void;
  isAiForMePage: boolean;
}

const RoutesContent: FC<RoutesProps> = ({ isDarkMode, onDarkModeToggle, isAiForMePage }) => {
  const history = useHistory();

  // Force re-render when navigating to update header
  useEffect(() => {
    const unlisten = history.listen(() => {
      // This will trigger a re-render
    });
    return unlisten;
  }, [history]);

  return (
    <>
      <Header isDarkMode={isDarkMode} onDarkModeToggle={isAiForMePage ? onDarkModeToggle : undefined} />
      <MessageBannersBox />
      <div className={isAiForMePage && isDarkMode ? "aiforme-dark-wrapper" : ""}>
        <Switch>
          <Route component={SearchResultsV2} exact path={Paths.search.url} sensitive />
          {/* Remove comment when enabling */}
          <Route component={FAQPage} path={Paths.faq.url} />
          <Route component={DetailsPage} exact path={Paths.detailsPage.url} sensitive />
          <Route component={SearchResultsHardwarePage} path={Paths.hardwareSearch.url} sensitive />
          <Route component={OrderConfirmation} path={Paths.confirmation.url} sensitive />
          <Route component={OrdersApprovalPage} exact path={Paths.approval.url} sensitive />
          <Route component={OrdersPage} exact path={Paths.orders.url} sensitive />
          <Route component={OrdersApprovalPage} exact path={Paths.ordersApproval.url} sensitive />
          <Route component={CheckoutPage} exact path={Paths.checkout.url} sensitive />
          <Route component={ListsPage} exact path={Paths.lists.url} sensitive />
          <Route component={ListsPage} exact path={Paths.aiForMeLists.url} sensitive />
          <Route component={ListsAdminPage} exact path={Paths.aiForMeAdminLists.url} sensitive />
          <Route component={AiForMePage} exact path={Paths.oldAiFormeHomePage.url} sensitive />
          <Route component={WhatsNew} exact path={Paths.whatsNew.url} sensitive />
          <Route component={AiForMeIntakePage} path={Paths.aiformeIntake.url} sensitive />
          <Route component={MyAiTools} path={Paths.aiformeMyTools.url} sensitive />
          <Route component={AllAiTools} exact path={Paths.aiForMeAllAiTools.url} sensitive />
          <Route component={AiForMeRouteComponent} path={Paths.aiforme.url} sensitive />
          <Route component={SessionExpired} exact path={Paths.sessionExpired.url} sensitive />
          <Route component={HomePage} exact path={Paths.home.url} sensitive />
          <Route component={NotFoundPage} path={Paths.notFound.url} />
        </Switch>
      </div>
    </>
  );
};

const Routes: FC<RoutesProps> = (props) => {
  return (
    <BrowserRouter>
      <RoutesContent {...props} />
    </BrowserRouter>
  );
};

export default Routes;
